import React from "react";
import moment from "moment-timezone";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  TextField,
  DialogTitle,
  Chip,
} from "@mui/material";

const ReleaseDetails = ({ note, open, close }) => {

      const formatDate = (d) => {
        const userTimezone = moment.tz.guess(); // e.g., "America/Los_Angeles"
    
        const formatted = moment.tz(d, userTimezone).format("YYYY-MM-DD");
        return formatted;
      };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{note?.summary}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography>Release Date: {formatDate(note?.releaseDate)}</Typography>
          </Grid>
          {note?.topics ? (
            <Grid item xs={12} style={{ display: "flex", gap: 5 }}>
              {note.topics.map((t) => {
                return <Chip key={t} label={t} size="small" />;
              })}
            </Grid>
          ) : null}
          <Grid item>
            <div dangerouslySetInnerHTML={{ __html: note?.htmlBody }} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReleaseDetails;
